export default "__VITE_ASSET__ca709e89__"